import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum TaskDepartmentId {
  RECEPTION = 1,
  HOUSEKEEPING = 2,
  RESERVATION = 3,
  MAINTENANCE = 4,
  MANAGEMENT = 5,
  OTHER = 6,
  KITCHEN = 7,
}

export class TaskDepartment extends Codebook<TaskDepartmentId> {
  static readonly RECEPTION = new TaskDepartment(TaskDepartmentId.RECEPTION, () =>
    $t('taskDepartment.reception'),
  )
  static readonly HOUSEKEEPING = new TaskDepartment(TaskDepartmentId.HOUSEKEEPING, () =>
    $t('taskDepartment.housekeeping'),
  )
  static readonly RESERVATION = new TaskDepartment(TaskDepartmentId.RESERVATION, () =>
    $t('taskDepartment.reservation'),
  )
  static readonly MAINTENANCE = new TaskDepartment(TaskDepartmentId.MAINTENANCE, () =>
    $t('taskDepartment.maintenance'),
  )
  static readonly MANAGEMENT = new TaskDepartment(TaskDepartmentId.MANAGEMENT, () =>
    $t('taskDepartment.management'),
  )
  static readonly KITCHEN = new TaskDepartment(TaskDepartmentId.KITCHEN, () =>
    $t('taskDepartment.kitchen'),
  )
  static readonly OTHER = new TaskDepartment(TaskDepartmentId.OTHER, () =>
    $t('taskDepartment.other'),
  )

  private constructor(
    id: TaskDepartmentId,
    public readonly name: () => string,
  ) {
    super(id)
  }
}
